export default __webpack_public_path__ + "static/media/wife5.2e61f630.png";